import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from '../material.module';
import {PipesModule} from '../pipes.module';
import {DirectivesModule} from '../directives.module';
import {PaginationComponent} from '../components/pagination/pagination.component';
import {DatepickerComponent, DatepickerRangeSelectionDirective} from '../components/datepicker/datepicker.component';
import {DatepickerCustomHeaderComponent} from '../components/datepicker/customHeader/datepicker-customHeader.component';
import {ScrollLoadComponent} from '../components/scroll-load-component/scroll-load.component';
import {AddRemoveComponent} from '../components/add-remove/add-remove.component';
import {PromocodeComponent} from '../components/promocode/promocode.component';
import {GiftCodeComponent} from '../components/gift-code/gift-code.component';
import {DatepickerCustomRangeHeaderComponent} from '../components/datepicker/customRangeHeader/datepicker-customRangeHeader.component';
import {ChipListComponent} from '../components/chip-list/chip-list.component';
import {BookingFooterComponent} from '../components/booking-footer/booking-footer.component';
import {AuditLogTableComponent} from '../components/audit-log-table/audit-log-table.component';
import {JsonDifferenceModalComponent} from '../components/audit-log-table/json-difference-modal/json-difference-modal.component';
import {TextEditorComponent} from '../components/text-editor/text-editor.component';
import {QuillModule} from 'ngx-quill'
import {AngularEditorModule} from '@kolkov/angular-editor';
import {HtmlEditorComponent} from '../components/html-editor/html-editor.component';
import {EventInfoPropsComponent} from '../components/event-info-props/event-info-props.component';
import {LabelValueComponent} from '../components/minor-components/label-value/label-value.component';
import {LoaderComponent} from '../components/minor-components/loader/loader.component';
import {DialogHeaderComponent} from '../components/dialog-components/dialog-header/dialog-header.component';
import {DialogFooterComponent} from '../components/dialog-components/dialog-footer/dialog-footer.component';
import {InfoMessageComponent} from '../components/minor-components/info-message/info-message.component'
import {PatternComponent} from '../components/pattern/pattern.component';
import {CompactHeaderComponent} from '../components/compact-header/compact-header.component';
import {UsersViewFormComponent} from '../modules/admin/users/view/form/users-view-form.component';
import {UsersViewLegalListComponent} from '../modules/admin/users/view/legal-list/users-view-legal-list.component';
import {PhoneInputComponent} from '../components/forms/phone-input/phone-input.component';
import {GoogleGeocodingComponent} from '../components/google/geocoding/google-geocoding.component';
import {GoogleAutocompleteComponent} from '../components/google/autocomplete/google-autocomplete.component';
import {TimeInputComponent} from '../components/time-input/time-input.component';
import {ReadMoreComponent} from '../components/read-more/read-more.component';
import {ShowMoreComponent} from '../components/show-more/show-more.component';
import {HtmlMoreComponent} from '../components/html-more/html-more.component';
import {S3UploaderComponent} from '../components/s3/uploader/s3-uploader.component';
import {S3ImageEditorComponent} from '../components/s3/image-editor/s3-image-editor.component';
import {S3DownloaderComponent} from '../components/s3/downloader/s3-downloader.component';
import {S3ImagePreviewComponent} from '../components/s3/image-preview/s3-image-preview.component';
import {CartTimerComponent} from '../components/cart-timer/cart-timer.component';
import {GoogleMapsModule} from '@angular/google-maps';
import {ImageCropperModule} from 'ngx-image-cropper';
import {DataTableComponent} from '../components/data-table/data-table.component';
import {NumericInputComponent} from '../components/forms/numeric-input/numeric-input.component';
import {FooterComponent} from '../components/footer/footer.component';
import {LangTabsComponent} from '../components/lang-tabs/lang-tabs.component';
import {LinkComponent} from '../components/minor-components/link/link.component';
import {TranslationTabsComponent} from '../components/translation-tabs/translation-tabs.component';
import {TextInputComponent} from '../components/forms/text-input/text-input.component';
import {SelectSearchComponent} from '../components/select-search/select-search.component';
import {EventQrCodeControlComponent} from '../components/event-qr-code-control/event-qr-code-control.component';
import {SectionHeaderComponent} from '../components/minor-components/section-header/section-header.component';
import {CommissionFeesComponent} from '../components/fees/commission-fees/commission-fees.component';
import {TotalsTableComponent} from '../components/totals-table/totals-table.component';
import {ReportTableComponent} from '../components/report-table/report-table.component';
import {EventInfoPropsPeriodComponent} from '../components/event-info-props/event-info-props-period/event-info-props-period.component';
import {ServiceFeesComponent} from '../components/fees/service-fees/service-fees.component';
import {CommissionFeeDialogComponent} from '../components/fees/commission-fee-dialog/commission-fee-dialog.component';
import {ServiceFeeDialogComponent} from '../components/fees/service-fee-dialog/service-fee-dialog.component';
import {EventAuditLogTableDialog} from '../components/audit-log-table-modal/event-audit-log-table-dialog.component';
import {DeliveryTypesComponent} from '../components/fees/delivery-types/delivery-types.component';
import {SelectionCardComponent} from '../components/selection-card/selection-card.component';
import {DeliveryTypeDialogComponent} from "../components/fees/delivery-type-dialog/delivery-type-dialog.component";
import {LegalPersonViewComponent} from "../components/legal-person-view/legal-person-view.component";

const components: any[] = [
  PaginationComponent,
  DatepickerComponent,
  DatepickerCustomHeaderComponent,
  DatepickerCustomRangeHeaderComponent,
  ScrollLoadComponent,
  DatepickerRangeSelectionDirective,
  AddRemoveComponent,
  PromocodeComponent,
  GiftCodeComponent,
  ChipListComponent,
  BookingFooterComponent,
  AuditLogTableComponent,
  JsonDifferenceModalComponent,
  TextEditorComponent,
  HtmlEditorComponent,
  EventInfoPropsComponent,
  EventInfoPropsPeriodComponent,
  LabelValueComponent,
  LoaderComponent,
  DialogHeaderComponent,
  DialogFooterComponent,
  InfoMessageComponent,
  PatternComponent,
  CompactHeaderComponent,
  UsersViewFormComponent,
  UsersViewLegalListComponent,
  PhoneInputComponent,
  GoogleGeocodingComponent,
  GoogleAutocompleteComponent,
  TimeInputComponent,
  ReadMoreComponent,
  ShowMoreComponent,
  HtmlMoreComponent,
  S3UploaderComponent,
  S3ImageEditorComponent,
  S3DownloaderComponent,
  S3ImagePreviewComponent,
  CartTimerComponent,
  DataTableComponent,
  NumericInputComponent,
  FooterComponent,
  LangTabsComponent,
  LinkComponent,
  TranslationTabsComponent,
  TextInputComponent,
  SelectSearchComponent,
  EventQrCodeControlComponent,
  EventAuditLogTableDialog,
  SectionHeaderComponent,
  CommissionFeesComponent,
  TotalsTableComponent,
  ReportTableComponent,
  ServiceFeesComponent,
  CommissionFeeDialogComponent,
  ServiceFeeDialogComponent,
  DeliveryTypesComponent,
  DeliveryTypeDialogComponent,
  SelectionCardComponent,
  LegalPersonViewComponent
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    QuillModule,
    AngularEditorModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    DirectivesModule,
    PipesModule,
    GoogleMapsModule,
    ImageCropperModule
  ],
  exports: [
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    DirectivesModule,
    PipesModule,
    GoogleMapsModule,
    ImageCropperModule,
    ...components
  ]
})

export class SharedModule {}
